import React from "react";
import {
  Box,
  Chip,
  Typography,
  Switch,
  FormControlLabel,
} from "@mui/material";

const GateVisitorsStatusChips = ({
  visitorTypes,
  selectedVisitorTypes,
  onVisitorTypeToggle,
  smartFilterEnabled,
  onToggleSmartFilter,
}) => {
  return (
    <Box sx={{ mb: 3 }}>
      {/* Visitor Type Filters */}
      {visitorTypes?.length > 0 && (
        <>
          <Typography variant="subtitle1" fontWeight="bold" mb={1}>
            Filter by Visitor Type
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
            {visitorTypes.map((type) => {
              const isActive = selectedVisitorTypes.includes(type.TypeID);
              return (
                <Chip
                  key={`type-${type.TypeID}`}
                  label={type.TypeName}
                  variant={isActive ? "filled" : "outlined"}
                  color={isActive ? "primary" : "default"}
                  onClick={() => onVisitorTypeToggle(type.TypeID)}
                  sx={{ cursor: "pointer", fontWeight: "bold" }}
                />
              );
            })}
          </Box>
        </>
      )}

      {/* Smart Filter Toggle */}
      <FormControlLabel
        control={
          <Switch
            checked={smartFilterEnabled}
            onChange={onToggleSmartFilter}
          />
        }
        label="Smart Filter"
        sx={{ mt: 1 }}
      />
    </Box>
  );
};

export default GateVisitorsStatusChips;
